import {BehaviorSubject, Subject} from "rxjs";
import {MenuItemSelection} from "../menu/menu-events";
import {OrderModel} from "./order.model";
import {OrderType} from "./order";

export class UnavailableOrderItemRemovalRequest {
    orderType?: OrderType;
    schedules?: boolean;
    confirm?: boolean;
}

export enum OrderInitiationStatus {
    UNINITIATED,
    INITIATING,
    INITIATED,
    FAILED
}

export enum OrderSubmissionStatus {
    SUBMITTING,
    COMPLETE,
    INCOMPLETE,
    ORDER_INVALID,
    ORDER_CANCELLED
}

export class OrderEvents {

    /**
     * Sent by: OrderModel
     * Notifies the model for use in objects into which it cannot be injected (order items).
     */
    public static readonly orderModel: BehaviorSubject<OrderModel> = new BehaviorSubject(undefined);

    /**
     * Notifies that a change has been made to the contents of the order.
     */
    public static readonly orderChanged$: Subject<void> = new Subject();

    /**
     * Notifies that an initiation request has been received.
     * This is intended to refresh components to reflect removal or addition of error messages.
     */
    public static readonly orderInitiationRequestReceived$: Subject<string> = new Subject();

    /**
     * Notifies whether there are any ordered items.
     */
    public static readonly orderHasItems$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    /**
     * Notifies the current order initiation status.
     */
    public static readonly orderInitiationStatus$: BehaviorSubject<OrderInitiationStatus> = new BehaviorSubject(OrderInitiationStatus.UNINITIATED);

    /**
     * Tracks whether the user has attempted to add the current item being ordered to the order.
     * This is intended to control whether certain messages are displayed as errors.
     */
    public static readonly addToOrderAttempted$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    /**
     * Notifies the current order submission status.
     * This is the local status of the order placement request submission, as distinct from the server-side placement status.
     */
    public static readonly orderSubmissionStatus$: BehaviorSubject<OrderSubmissionStatus> = new BehaviorSubject(undefined);

    /**
     * Notifies that the current order is complete.
     */
    public static readonly orderComplete$: Subject<void> = new Subject();

    /**
     * Requests ordering of the specified item.
     */
    public static readonly requestOrderItem$: Subject<MenuItemSelection> = new Subject();
}



// WEBPACK FOOTER //
// ./src/app/order/order-events.ts